import { SimpleSelect } from 'libs/ui';
import { zones } from 'services/zones';

export const ZoneSelect = (props) => {
  const { current, ...rest } = props;
  const items = zones.getZones();
  const data = rest.disabled ? items : current;
  // console.log('🚀 ~ ZoneSelect ~ items:', current);

  const getItemsEl = () => {
    return (
      data
        // .filter((el) => {
        //   return current.includes(el.zone_id);
        // })
        .map((el, idx) => {
          return (
            <option key={idx} value={el.zone_id}>
              {el.name}
            </option>
          );
        })
    );
  };

  const itemsEl = getItemsEl();

  return <SimpleSelect {...rest}>{itemsEl}</SimpleSelect>;
};
